export enum StepperId {
  APPLY = "apply",
}
